import {Component, Inject}                              from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogModule, MatDialogRef} from '@angular/material/dialog';

@Component({
    selector: 'app-dialog',
    templateUrl: './dialog.component.html',
    styleUrls: ['./dialog.component.scss'],
    standalone: false,
})
export class DialogComponent
{
    public constructor(
        @Inject(MAT_DIALOG_DATA)
        public data: {
            title: string,
            message: string,
            type: 'confirm' | 'danger' | 'danger-outline',
            confirmButtonLabel?: string,
            cancelButtonLabel?: string
        },
        public dialogRef: MatDialogRef<DialogComponent>
    )
    {
    }
}
